module.exports = __webpack_public_path__ + "media/common/js/components/content-units/templates/innogy-style/i1-4-4a57f802ad2095a582df14dfbb057903.svg";